var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            width: "640px",
            title: _vm.$t("Edit User")
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.userForm,
                "label-width": "80px",
                rules: _vm.rules,
                "inline-message": ""
              }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "username",
                    label: _vm.$t("Username"),
                    required: ""
                  }
                },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: _vm.$t("Username"),
                      disabled: !_vm.isAdd
                    },
                    model: {
                      value: _vm.userForm.username,
                      callback: function($$v) {
                        _vm.$set(_vm.userForm, "username", $$v)
                      },
                      expression: "userForm.username"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "password",
                    label: _vm.$t("Password"),
                    required: ""
                  }
                },
                [
                  _c("el-input", {
                    attrs: {
                      type: "password",
                      placeholder: _vm.$t("Password")
                    },
                    model: {
                      value: _vm.userForm.password,
                      callback: function($$v) {
                        _vm.$set(_vm.userForm, "password", $$v)
                      },
                      expression: "userForm.password"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { prop: "role", label: _vm.$t("Role"), required: "" }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: _vm.$t("Role") },
                      model: {
                        value: _vm.userForm.role,
                        callback: function($$v) {
                          _vm.$set(_vm.userForm, "role", $$v)
                        },
                        expression: "userForm.role"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { value: "admin", label: _vm.$t("admin") }
                      }),
                      _c("el-option", {
                        attrs: { value: "normal", label: _vm.$t("normal") }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "email", label: _vm.$t("Email") } },
                [
                  _c("el-input", {
                    attrs: { placeholder: _vm.$t("Email") },
                    model: {
                      value: _vm.userForm.email,
                      callback: function($$v) {
                        _vm.$set(_vm.userForm, "email", $$v)
                      },
                      expression: "userForm.email"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "template",
            { slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function($event) {
                      _vm.dialogVisible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.onConfirm }
                },
                [_vm._v(_vm._s(_vm.$t("Confirm")))]
              )
            ],
            1
          )
        ],
        2
      ),
      _c(
        "el-card",
        [
          _c("div", { staticClass: "filter" }, [
            _c("div", { staticClass: "left" }),
            _c(
              "div",
              { staticClass: "right" },
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "success",
                      icon: "el-icon-plus",
                      size: "small"
                    },
                    on: { click: _vm.onClickAddUser }
                  },
                  [_vm._v("添加用户")]
                )
              ],
              1
            )
          ]),
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.userList,
                "header-cell-style": {
                  background: "rgb(48, 65, 86)",
                  color: "white"
                },
                border: ""
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  width: "120px",
                  label: _vm.$t("Username"),
                  prop: "username"
                }
              }),
              _c("el-table-column", {
                attrs: { width: "150px", label: _vm.$t("Role") },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.username === "admin"
                          ? _c("el-tag", { attrs: { type: "success" } }, [
                              _vm._v(" " + _vm._s(_vm.$t("Super Admin")) + " ")
                            ])
                          : scope.row.role === "admin"
                          ? _c("el-tag", { attrs: { type: "primary" } }, [
                              _vm._v(" " + _vm._s(_vm.$t(scope.row.role)) + " ")
                            ])
                          : _c("el-tag", { attrs: { type: "warning" } }, [
                              _vm._v(" " + _vm._s(_vm.$t(scope.row.role)) + " ")
                            ])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { width: "150px", label: _vm.$t("Create Time") },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          " " + _vm._s(_vm.getTime(scope.row.create_ts)) + " "
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: _vm.$t("Action"), fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm.isShowEdit(scope.row)
                          ? _c("el-button", {
                              attrs: {
                                icon: "el-icon-edit",
                                type: "warning",
                                size: "mini"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onEdit(scope.row)
                                }
                              }
                            })
                          : _vm._e(),
                        _vm.isShowRemove(scope.row)
                          ? _c("el-button", {
                              attrs: {
                                icon: "el-icon-delete",
                                type: "danger",
                                size: "mini"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onRemove(scope.row)
                                }
                              }
                            })
                          : _vm._e()
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.pageNum,
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.pageSize,
                  layout: "sizes, prev, pager, next",
                  total: _vm.totalCount
                },
                on: {
                  "update:currentPage": function($event) {
                    _vm.pageNum = $event
                  },
                  "update:current-page": function($event) {
                    _vm.pageNum = $event
                  },
                  "update:pageSize": function($event) {
                    _vm.pageSize = $event
                  },
                  "update:page-size": function($event) {
                    _vm.pageSize = $event
                  },
                  "current-change": _vm.onPageChange,
                  "size-change": _vm.onPageChange
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }